package com.ijoin.i18n

/**
 * Russian strings implementation
 */
object RussianStrings : Strings {
    override val appName = "iJoin"
    override val clickMe = "Нажми на меня!"
    override val greetingMessage = "Compose"
    override fun helloPlatform(platformName: String) = "Привет, $platformName!"
    override val language = "Язык"
    override val english = "Английский"
    override val russian = "Русский"
    override val changeLanguage = "Изменить язык"
    override val ok = "ОК"
    override val cancel = "Отмена"
    override val save = "Сохранить"
    override val delete = "Удалить"
    override val edit = "Редактировать"
    override val close = "Закрыть"
    override val retry = "Повторить"
    override val share = "Поделиться"
    override val unknownErrorMessage = "Что-то пошло не так. Попробуйте ещё раз."
    override val missingEventDateError = "Не указана дата события."
    override val slotSelectionRequired = "Выберите хотя бы один слот."
    override val userContextMissingError = "Не удалось определить пользователя."
    override val cancelSlotsSelectionRequired = "Выберите хотя бы один слот для отмены."
    override val cancelDaySelectionRequired = "Выберите день для отмены."
    override val restoreSlotsSelectionRequired = "Выберите хотя бы один слот для восстановления."
    override val restoreDaySelectionRequired = "Выберите день для восстановления."
    override val cancelSlotsFailed = "Не удалось отменить выбранные слоты."
    override val cancelDayFailed = "Не удалось отменить выбранный день."
    override val restoreSlotsFailed = "Не удалось восстановить выбранные слоты."
    override val restoreDayFailed = "Не удалось восстановить выбранный день."
    override val cancelEventFailed = "Не удалось отменить событие."
    override val restoreEventFailed = "Не удалось восстановить событие."
    override val deleteEventFailed = "Не удалось удалить событие."
    override val selectedDateUnavailableError = "Выбранная дата недоступна."
    override val selectedDateInPastError = "Выбранная дата уже прошла."
    override val notSelected = "Не выбрано"
    override fun atTime(time: String) = "в $time"
    override val enableNotificationsTitle = "Будьте в курсе"
    override val enableNotificationsBody =
        "Включите уведомления браузера, чтобы получать новости о событиях и сообщениях."
    override val allowNotificationsAction = "Включить уведомления"
    override val notNowAction = "Не сейчас"
    override val searchPlaceholder = "Поиск событий, организаторов, локаций..."
    override val myTickets = "Мои билеты"
    override val tapToViewTicket = "Нажмите для просмотра билета"
    override val favoriteEvents = "Избранное"
    override val eventsYouSaved = "События, которые вы сохранили"
    override val recommendedForYou = "Рекомендовано для вас"
    override val curatedEvents = "Подборка событий на основе ваших интересов"
    override val recommendations = "Рекомендации"
    override val upcomingEvents = "Предстоящие события"
    override val searchResults = "Результаты поиска"
    override val noResults = "Ничего не найдено"
    override val noAvailableEvents = "Нет доступных событий"
    override val createEvent = "Создать расписание"
    override val menu = "Меню"
    override val home = "Главная"
    override val explore = "Обзор"
    override val tickets = "Билеты"
    override val profile = "Профиль"
    override val upcomingPaidTicketsTitle = "Оплаченные ближайшие билеты"
    override val otherTicketsTitle = "Все билеты"
    override val offlineTicketsNotice = "Показаны сохранённые билеты. Данные могут быть неактуальными."
    override val ticketsEmptyMessage = "У вас пока нет билетов."
    override val ticketDetailsTitle = "Детали билета"
    override val ticketNumberLabel = "Номер билета"
    override val ticketStatusActive = "Активен"
    override val ticketStatusCancelled = "Отменён"
    override val ticketStatusRefunded = "Возвращён"
    override val ticketStatusUsed = "Использован"
    override val ticketHolderLabel = "Владелец"
    override val cancelTicketAction = "Отменить билет"
    override val ticketCancellationConfirmTitle = "Отменить билет?"
    override val ticketCancellationConfirmMessage = "После отмены место снова станет доступным другим пользователям."
    override val ticketCancellationSuccess = "Билет отменён"
    override val ticketCancellationFailure = "Не удалось отменить билет"
    override val ticketLoadError = "Не удалось загрузить билет"
    override val refresh = "Обновить"
    override val settings = "Настройки"
    override val createEventTitle = "Создать событие"
    override val eventTitle = "Название события"
    override val eventTitlePlaceholder = "Введите название события"
    override val eventDescription = "Описание"
    override val eventDescriptionPlaceholder = "Опишите событие..."
    override val aiGenerateDescription = "AI придумать описание"
    override val aiFormatDescription = "Структурировать/финализировать описание"
    override val addMedia = "Добавить фото/видео"
    override val mediaDesktopLabel = "Для компьютера (широкие)"
    override val mediaMobileLabel = "Для мобильных устройств (квадратное)"
    override val mediaChooseFile = "Выбрать файл"
    override val location = "Место проведения"
    override val onlineEvent = "Онлайн событие"
    override val onlineLink = "Ссылка на онлайн-трансляцию"
    override val onlineLinkPlaceholder = "https://example.com/meeting"
    override val onlineLinkNotice = "Ссылка станет доступна после оплаты"
    override val placeName = "Название места"
    override val address = "Адрес"
    override val ticketPrice = "Цена билета"
    override val ticketPricePlaceholder = "25,00"
    override val dateAndTime = "Дата и время"
    override val recurringEvent = "Регулярное событие"
    override val recurrenceType = "Тип повторения"
    override val daysOfWeek = "Дни недели"
    override val daysOfMonth = "Дни месяца"
    override val selectDaysOfWeek = "Выберите дни недели"
    override val selectDaysOfMonth = "Выберите дни месяца"
    override val time = "Время (ЧЧ:ММ)"
    override val hiddenInfo = "Скрытая информация"
    override val hiddenInfoDescription = "Будет доступна пользователям после оплаты билета"
    override val hiddenInfoPlaceholder = "Информация откроется после оплаты..."
    override val enableGroupChatLabel = "Создать групповой чат"
    override val enableGroupChatDescription = "Все, кто купил билет или сделал бронь, автоматически попадают в общий чат события."
    override val groupChatLabel = "Групповой чат"
    override val groupChatSubtitle = "Чат для всех участников"
    override val carpoolSettings = "Настройки совместных поездок (Carpool)"
    override val enableCarpool = "Включить возможность совместных поездок"
    override val contactInfoSettings = "Сбор контактной информации"
    override val requireContactInfo = "Собирать контактную информацию"
    override val requireContactInfoDescription = "Требовать от клиентов предоставить телефон и дополнительную информацию при бронировании"
    override val freeCarpool = "Бесплатные поездки"
    override val carpoolPaymentPerPerson = "Оплата водителю за каждого пассажира (₽)"
    override fun carpoolPaymentLabel(symbol: String) = "Оплата за человека ($symbol)"
    override val carpoolPaymentPlaceholder = "10,00"
    override val carpoolDescription = "Пользователи смогут отметить, что у них есть машина, и указать количество пассажиров, которых они могут подвезти"
    override val carpoolPaymentHint = "Укажите стоимость поездки для одного участника"
    override val selectDate = "Выберите дату"
    override val back = "Назад"
    override val create = "Создать"
    override val currency = "Валюта"
    override val selectCurrency = "Выберите валюту"
    override val category = "Категория"
    override val selectCategory = "Выберите категорию"
    override val tags = "Теги"
    override val addTag = "Добавить тег"
    override val maxCapacity = "Максимальная вместимость"
    override val maxCapacityPlaceholder = "50"
    override val duration = "Длительность"
    override val durationMinutes = "Длительность (минуты)"
    override fun formatDuration(minutes: Int): String {
        if (minutes <= 0) return ""
        val days = minutes / (24 * 60)
        val hours = (minutes % (24 * 60)) / 60
        val mins = minutes % 60

        return when {
            days >= 7 -> {
                val weeks = days / 7
                val remainingDays = days % 7
                if (remainingDays > 0) "$weeks нед. $remainingDays дн."
                else "$weeks нед."
            }
            days > 0 -> {
                if (hours > 0) "$days дн. $hours ч"
                else "$days дн."
            }
            hours > 0 -> {
                if (mins > 0) "$hours ч $mins мин"
                else "$hours ч"
            }
            else -> "$mins мин"
        }
    }
    override val locationCountry = "Страна"
    override val selectOnMap = "Выбрать на карте"
    override val locationSearchPlaceholder = "Введите адрес или название места"
    override val onlineLinkHidden = "Ссылка станет видна только после оплаты"
    override val timeZone = "Часовой пояс"
    override fun timeZoneValue(timeZoneId: String) = "Часовой пояс: $timeZoneId"
    override val selectTimeZone = "Выберите часовой пояс"
    override val localTimeZone = "Локальный часовой пояс"
    override val mediaFilesAdded = "Добавлено файлов"
    override val free = "Бесплатно"
    override val priceForFreeEvent = "0 - для бесплатного события"
    override val additionalOptions = "Дополнительные опции"
    override val ageRestriction = "Возрастные ограничения"
    override val languageEvent = "Язык события"
    override val contactInfo = "Контактная информация"
    override val website = "Веб-сайт"
    override val phone = "Телефон"
    override val email = "Email"
    override val comment = "Комментарий"
    override val phoneRequired = "Телефон обязателен"
    override val city = "Город"
    override val search = "Поиск"
    override val year = "Год"
    override val month = "Месяц"
    override val day = "День"
    override fun weekdayShortName(index: Int) = listOf("Пн", "Вт", "Ср", "Чт", "Пт", "Сб", "Вс")[index % 7]
    override fun weekdayName(index: Int) = listOf(
        "Понедельник",
        "Вторник",
        "Среда",
        "Четверг",
        "Пятница",
        "Суббота",
        "Воскресенье"
    )[index % 7]
    override fun monthNameFull(month: Int) = listOf(
        "Январь",
        "Февраль",
        "Март",
        "Апрель",
        "Май",
        "Июнь",
        "Июль",
        "Август",
        "Сентябрь",
        "Октябрь",
        "Ноябрь",
        "Декабрь"
    )[(month - 1).mod(12)]
    override fun monthNameGenitive(month: Int) = listOf(
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря"
    )[(month - 1).mod(12)]
    override val createEventWizard = "Создать событие"
    override val step = "Шаг"
    override val of = "из"
    override val next = "Далее"
    override val previous = "Назад"
    override val saveDraft = "Сохранить черновик"
    override val editEvent = "Редактировать событие"
    override val step1BasicInfo = "Основная информация"
    override val step2Schedule = "Расписание"
    override val scheduleTypeLabel = "Тип расписания"
    override val scheduleOneTimeDescription = "Разовое событие в выбранную дату"
    override val scheduleWeeklyDescription = "Повторяется по выбранным дням недели"
    override val scheduleSlotDescription = "Календарь доступных слотов"
    override val scheduleOneTimeSetup = "Настройка разового события"
    override val schedulePreviewTitle = "Предпросмотр"
    override fun schedulePreviewDate(date: String) = "Дата: $date"
    override fun schedulePreviewTime(start: String, end: String) = "Время: $start — $end"
    override val step3Location = "Место проведения"
    override val eventSetupTitle = "Настройка события"
    override val eventTypeLabel = "Тип события"
    override val oneTimeEvent = "Разовое мероприятие"
    override val eventSeries = "Серия мероприятий"
    override val weekly = "Еженедельное"
    override val monthly = "Ежемесячное"
    override val slotBooking = "Бронирование слота по календарю"
    override val slotLabel = "Слот"
    override val slotsLabel = "Слоты"
    override val selectDayOfWeek = "Выберите день недели"
    override val selectDayOfMonth = "Выберите день месяца"
    override val availableTimeRange = "Доступный диапазон времени"
    override val startTime = "Время начала"
    override val endTime = "Время окончания"
    override val endDateLabel = "Дата окончания (при необходимости)"
    override val invalidEndDate = "Дата окончания должна быть не раньше даты начала"
    override val invalidEndTime = "Время окончания должно быть позже времени начала"
    override val eventDateMustBeFuture = "Дата мероприятия должна быть в будущем"
    override val eventTimeMustBeFuture = "Время мероприятия должно быть позже текущего времени"
    override val slotSettings = "Настройки слотов"
    override val minSlots = "Мин. слотов"
    override val minSlotsPlaceholder = "1"
    override val slotDuration = "Длительность (мин)"
    override val slotDurationPlaceholder = "30"
    override val perDayTimeConfiguration = "Доступное время для каждого дня"
    override val driverCompensation = "Компенсация водителю"
    override val fixedAmountPerPassenger = "Фиксированная сумма за каждого пассажира"
    override val coordinateRide = "Координация поездки"
    override val participantsWithCar = "Участники с авто"
    override val needRide = "Нужна поездка"
    override val draft = "Черновик"
    override val saved = "Сохранено"
    override val eventSaveErrorTitle = "Не удалось сохранить мероприятие"
    override val eventSaveErrorMessage = "Произошла ошибка при сохранении мероприятия. Попробуйте ещё раз."
    override val deleteEventTitle = "Удалить мероприятие?"
    override val deleteEventMessage = "Мероприятие будет удалено навсегда. Продолжить?"
    override val eventDeletedMessage = "Мероприятие удалено"
    override val organizerLabel = "Организатор"
    override val online = "Онлайн"
    override val offline = "Оффлайн"
    override val eventDetailsTitle = "Детали события"
    override val addToFavorites = "В избранное"
    override val removeFromFavorites = "Убрать из избранного"
    override val ticketTierStandard = "Стандарт"
    override fun ticketsAvailable(count: Int) = "Доступно: $count билетов"
    override val viewTicket = "Посмотреть билет"
    override val bookingRequestFailed = "Не удалось забронировать билет"
    override val contactSendFailed = "Не удалось отправить контактные данные"
    override val slotLoadFailed = "Не удалось загрузить слоты"
    override val slotBookingFailed = "Не удалось забронировать слоты"
    override val ticketIssuanceFailed = "Не удалось выдать билеты"
    override val unexpectedReservation = "Неожиданная бронь для бесплатного события"
    override val sampleReviewerName = "Анна Петрова"
    override val sampleReviewTimeAgo = "2 дня назад"
    override val selectVisitDate = "Выберите дату посещения"
    override fun availableDaysLabel(days: String) = "Доступные дни: $days"
    override val previousMonth = "Предыдущий месяц"
    override val nextMonth = "Следующий месяц"
    override fun slotSelectionMessage(date: String, time: String?) =
        if (time.isNullOrBlank()) "Вы выбрали: $date" else "Вы выбрали: $date в $time"
    override fun eventImageContentDescription(title: String, index: Int) = "$title — изображение $index"
    override val dateTbd = "Уточняется"
    override val recurringWeeklyDescription = "Мероприятие проходит каждую неделю в выбранные дни."
    override val recurringMonthlyDescription = "Мероприятие проходит ежемесячно в выбранные дни недели."
    override val userCardTitle = "Профиль организатора"
    override val followAction = "Подписаться"
    override val followingAction = "Вы подписаны"
    override val followersCountLabel = "Подписчики"
    override val followingCountLabel = "Подписки"
    override val eventsCountLabel = "События"
    override val organizerEventsTitle = "Предстоящие события"
    override val archiveSectionTitle = "Архив"
    override val aboutOrganizerTitle = "Об организаторе"
    override val userEventsEmpty = "У организатора пока нет предстоящих событий."
    override val userArchiveEmpty = "Нет архивных событий."
    override val addShortcutTitle = "Добавить ярлык?"
    override fun addShortcutMessage(displayName: String) =
        "Добавить $displayName на главный экран для быстрого доступа к событиям?"
    override val addShortcutConfirm = "Добавить"
    override val addShortcutDismiss = "Не сейчас"
    override val dateLabel = "Дата"
    override val participants = "Участники"
    override val spotsLeft = "осталось мест"
    override val ticketQuantityLabel = "Количество билетов"
    override val increaseQuantity = "Увеличить количество"
    override val decreaseQuantity = "Уменьшить количество"
    override val costLabel = "Стоимость участия"
    override val serviceFee = "Сервисный сбор"
    override val totalAmount = "Итого"
    override fun serviceFeePercent(percent: Int) = "Сервисный сбор ($percent%)"
    override val dressCode = "Дресс-код"
    override val dressCodePlaceholder = "Например: деловой стиль"
    override val description = "Описание"
    override val reviews = "Отзывы"
    override val allReviews = "Все отзывы"
    override val contactOrganizer = "Связаться с организатором"
    override val slotBookingsTitle = "Бронирования слотов"
    override val slotBookingsEmptyMessage = "Пока нет броней."
    override val showAllBookings = "Все"
    override val showToday = "Сегодня"
    override val showThisMonth = "За месяц"
    override val showSelectedDate = "Выбранная дата"
    override val noBookingsForSelectedDate = "Нет бронирований на эту дату."
    override val noTicketsForSelectedDate = "Нет билетов на эту дату."
    override fun totalCount(count: Int) = "Всего: $count"
    override val cancelEventAction = "Отменить событие"
    override val cancelEventDescription = "Остановить продажу билетов и отметить событие как отменённое для всех участников."
    override val organizerActionsTitle = "Инструменты организатора"
    override val eventAlreadyCancelledNotice = "Событие уже отменено."
    override val eventCancelledTitle = "Событие отменено"
    override val eventCancelledSubtitle = "Организатор отменил событие. Бронирование больше недоступно."
    override val unpublishedBookingNotice = "Бронирование будет доступно после публикации события."
    override val cancellationReasonLabel = "Причина отмены"
    override val cancellationReasonPlaceholder = "Опишите, почему вы отменяете событие"
    override val cancellationReasonRequired = "Пожалуйста, укажите краткую причину."
    override val cancelSelectedSlotsAction = "Отменить выбранные слоты"
    override val cancelSelectedSlotsDescription = "Участники больше не смогут бронировать выбранные слоты."
    override val cancelSlotDayAction = "Отменить выбранный день"
    override val cancelSlotDayDescription = "Все слоты выбранного дня будут заблокированы."
    override val selectedSlotsLabel = "Выбранные слоты"
    override val selectedDayLabel = "Выбранный день"
    override val restoreEventAction = "Возобновить событие"
    override val restoreEventDescription = "Снова открыть событие для участников после отмены."
    override val restoreSelectedSlotsAction = "Вернуть выбранные слоты"
    override val restoreSelectedSlotsDescription = "Снова разрешить бронирование выбранных слотов."
    override val restoreSlotDayAction = "Вернуть выбранный день"
    override val restoreSlotDayDescription = "Снова открыть все слоты выбранного дня."
    override val bookingStatusPending = "В ожидании"
    override val bookingStatusConfirmed = "Подтверждена"
    override val bookingStatusCancelled = "Отменена"
    override val bookingStatusCompleted = "Забронировано"
    override val bookingStatusNoShow = "Не пришёл"
    override val viewDetails = "Подробнее"
    override val hideDetails = "Скрыть"
    override val openChat = "Перейти в чат"
    override val clientNotesLabel = "Комментарий клиента"
    override val bookingDetailsTitle = "Детали брони"
    override val slotBookedByLabel = "Забронировал"
    override val slotAvailableLabel = "Свободно"
    override val statusLabel = "Статус"
    // Stripe Connect
    override val connectTitle = "Прямые выплаты"
    override val connectStatusActive = "Активно"
    override val connectStatusPending = "Ожидание"
    override val connectStatusPlatform = "Платформа"
    override val connectStatusUnderReview = "На проверке"
    override val connectStatusSetupNeeded = "Требуется настройка"
    override val connectEnableDirectAction = "Включить прямые выплаты"
    override val connectContinueOnboarding = "Продолжить настройку"
    override val connectOpenDashboard = "Открыть панель Stripe"
    override val connectSwitchToPlatform = "Вернуться на платформу"
    override val connectPlatformFeeLabel = "Комиссия платформы"
    override val connectDirectPaymentsEnabled = "Прямые выплаты включены"
    override val connectSwitchedToPlatform = "Переключено на платёжи через платформу"
    override val connectOnboardingDescription = "Настройте аккаунт Stripe для получения платежей напрямую"
    override val connectActiveDescription = "Платежи поступают напрямую на ваш аккаунт Stripe"
    override val connectPlatformDescription = "Платежи обрабатываются через платформу"
    override val connectUnderReviewDescription = "Ваш аккаунт проверяется Stripe"
    override fun connectPlatformFeeValue(percent: Int) = "$percent%"

    override val billingTitle = "Биллинг"
    override val currentBalanceLabel = "Текущий баланс"
    override val openBillingAction = "Открыть биллинг"
    override val withdrawFundsAction = "Вывести средства"
    override val pendingPayoutsLabel = "В ожидании"
    override val withdrawnTotalLabel = "Выведено"
    override val billingFilterWeek = "Неделя"
    override val billingFilterMonth = "30 дней"
    override val billingFilterQuarter = "90 дней"
    override val grossSalesLabel = "Выручка"
    override val feesLabel = "Комиссия"
    override val netRevenueLabel = "Чистый доход"
    override val payoutRequestsTitle = "Заявки на вывод"
    override val payoutRequestsEmpty = "Ещё нет заявок"
    override val payoutStatusPending = "Ожидает"
    override val payoutStatusProcessing = "В работе"
    override val payoutStatusPaid = "Выплачено"
    override val payoutStatusRejected = "Отклонено"
    override val requisitesTitle = "Реквизиты"
    override val requisitesAccountLabel = "Расчётный счёт"
    override val requisitesInnLabel = "ИНН"
    override val requisitesKppLabel = "КПП"
    override val requisitesBikLabel = "БИК"
    override val bankLabel = "Банк"
    override val soldTicketsTitle = "Проданные билеты"
    override val soldTicketsEmpty = "Продаж за выбранный период пока нет"
    override val withdrawConfirmTitle = "Вывести средства?"
    override fun withdrawConfirmMessage(amount: String) =
        "Отправить заявку на вывод на сумму $amount."
    override val billingWithdrawSuccess = "Заявка на вывод отправлена"
    override val billingWithdrawFailed = "Не удалось отправить заявку на вывод"
    override val billingWithdrawUnavailable = "Недостаточно средств для вывода"
    override val payoutMethodEtransfer = "eTransfer (Канада)"
    override val payoutMethodWise = "Перевод через Wise"
    override val payoutDetailsTitle = "Реквизиты выплаты"
    override val payoutEmailLabel = "Email получателя"
    override val payoutWiseNameLabel = "Имя владельца счёта"
    override val payoutWiseAccountLabel = "Номер счёта / IBAN"
    override val payoutWiseBankLabel = "Банк / SWIFT"
    override val payoutWiseRoutingLabel = "Маршрутный номер"
    override val payoutWiseAccountTypeLabel = "Тип счёта"
    override val payoutAccountTypeChecking = "Чековый"
    override val payoutAccountTypeSavings = "Сберегательный"
    override val payoutNoteLabel = "Примечание (опционально)"
    override fun soldTicketQuantity(quantity: Int, grossAmount: String) =
        "$quantity шт. x $grossAmount"
    override fun soldTicketBuyerInfo(buyerName: String, soldAt: String) =
        "$buyerName - $soldAt"
    override fun soldTicketServiceFee(fee: String) = "- $fee"
    override fun shortMonthName(month: Int): String = when (month) {
        1 -> "янв"
        2 -> "фев"
        3 -> "мар"
        4 -> "апр"
        5 -> "май"
        6 -> "июн"
        7 -> "июл"
        8 -> "авг"
        9 -> "сен"
        10 -> "окт"
        11 -> "ноя"
        12 -> "дек"
        else -> ""
    }
    override val accountDetails = "Данные аккаунта"
    override val interfaceLanguage = "Язык интерфейса"
    override val profileSavedMessage = "Профиль обновлён"
    override val profileLogoutDescription = "Выйти из аккаунта на этом устройстве."
    override val profileLoadError = "Не удалось загрузить профиль"
    override val logoutError = "Не удалось выйти. Попробуйте снова."
    override val profileDeletedMessage = "Аккаунт удалён"
    override val deleteAccountTitle = "Удалить аккаунт"
    override val deleteAccountDescription = "Мы деактивируем аккаунт и обнулим личные данные. Вернуть доступ будет нельзя."
    override val deleteAccountAction = "Удалить аккаунт"
    override val deleteAccountConfirmMessage = "Перед удалением убедитесь, что баланс обнулён и отправлены заявки на вывод средств."
    override val aiConsentSectionTitle = "Обработка данных ИИ"
    override val aiConsentEnabled = "Вы дали согласие на передачу данных ИИ-сервисам (OpenAI, Google) для функций транскрибации и генерации описаний."
    override val aiConsentDisabled = "Согласие на обработку данных ИИ не активно. ИИ-функции недоступны."
    override val aiConsentWithdrawButton = "Отозвать согласие"
    override val aiConsentEnableButton = "Включить ИИ-функции"
    override val aiConsentWithdrawConfirmTitle = "Отозвать согласие на ИИ?"
    override val aiConsentWithdrawConfirmMessage = "ИИ-функции (транскрибация, генерация описаний, лендинги) станут недоступны. Вы сможете включить их снова в любое время."
    override val aiConsentWithdrawnSuccess = "Согласие на обработку данных ИИ отозвано"
    override val aiConsentEnabledSuccess = "Согласие на обработку данных ИИ получено"
    override val messagesTitle = "Сообщения"
    override val emptyChatList = "У вас ещё нет чатов"
    override val emptyMessages = "Сообщений пока нет. Напишите первым!"
    override val typeMessage = "Напишите сообщение..."
    override val send = "Отправить"
    override val chatSearchPlaceholder = "Поиск пользователя по имени"
    override val chatSearchNoResults = "Пользователи не найдены"
    override val chatLoadError = "Не удалось загрузить сообщения"
    override val chatSendError = "Не удалось отправить сообщение"
    override val chatOpenError = "Не удалось открыть чат"
    override val chatStartError = "Не удалось начать чат"
    override val chatSearchError = "Не удалось выполнить поиск"
    override val paymentTitle = "Оплата бронирования"
    override val paymentSubtitle = "Оплатите бронирование события"
    override val paymentDescription = "После успешного платежа статус вашей резервации изменится автоматически."
    override val paymentPreparing = "Подготавливаем платеж в Stripe..."
    override val paymentFetchingTickets = "Получаем ваши билеты..."
    override val paymentCompletedMessage =
        "Платеж подтверждён. Если билеты не открылись автоматически, обновите список ниже."
    override val paymentStripePopupHint =
        "Stripe откроется во всплывающем окне. Если окно не появилось или вы его закрыли, нажмите «Перезапустить оплату»."
    override val paymentRetryButton = "Перезапустить оплату"
    override val paymentRetryTicketsButton = "Получить билеты ещё раз"
    override val paymentStartFailed = "Не удалось начать оплату"
    override val paymentTicketContextMissing = "Не удалось определить бронирование для получения билетов"
    override val paymentTicketsNotFound = "Билеты не найдены"
    override val paymentTicketsFetchFailed = "Не удалось получить билеты"
    override val paymentStripeOverlayTitle = "Платёж Stripe"
    override val paymentStripeOverlayDescription = "Введите данные карты, чтобы завершить бронирование."
    override val paymentStripeOverlayPayButton = "Оплатить сейчас"
    override val paymentStripeOverlayPayButtonLoading = "Обработка..."
    override val paymentStripeOverlayCancelButton = "Отмена"
    override val paymentStripeOverlayOpenError = "Не удалось открыть страницу оплаты Stripe."
    override val paymentStripeOverlayCancelMessage = "Платёж отменён"
    override val paymentStripeOverlayInitError = "Не удалось инициализировать Stripe."
    override val paymentStripeOverlayPaymentFailed = "Платёж не выполнен"
    override val paymentStripeOverlayUnexpectedStatusPrefix = "Неожиданный статус: "
    override val paymentStripeOverlayProcessingFailed = "Не удалось обработать платёж"
    override val errorUserNotAuthenticated = "Пожалуйста, войдите, чтобы продолжить."
    override val errorAccessDenied = "У вас нет прав для выполнения этого действия."
    override val errorForbiddenFollowingList = "Можно просматривать только собственный список подписок."
    override val errorDataUrlRequired = "Требуется изображение в формате dataUrl."
    override val errorMediaStoreFailed = "Не удалось сохранить файл. Попробуйте ещё раз."
    override val errorAmountMustBePositive = "Сумма должна быть больше нуля."
    override val errorAmountExceedsBalance = "Запрошенная сумма превышает доступный баланс."
    override val errorPayoutEmailRequired = "Для eTransfer необходимо указать email."
    override val errorPayoutWiseInfoRequired = "Для выплат через Wise нужны ФИО, routing number и номер счёта."
    override val errorPayoutAccountType = "Поддерживаются только типы счёта checking или savings."
    override val errorUnsupportedPayoutMethod = "Этот способ вывода не поддерживается."
    override val errorEventNotCancelled = "Событие не отменено."
    override val errorChatWithSelf = "Нельзя начать чат с самим собой."
    override val errorChatMessageEmpty = "Сообщение не может быть пустым."
    override val errorEventOrganizerRequired = "Нужны данные события и организатора."
    override val errorEventUnavailable = "Событие больше недоступно."
    override val errorEventFinished = "Событие уже завершилось."
    override val errorOrganizerNotProvider = "Организатор не предоставляет услуги."
    override val errorServiceProviderInactive = "Организатор сейчас неактивен."
    override val errorSlotsNotFound = "Некоторые тайм-слоты не найдены."
    override val errorSlotsMustSameEvent = "Все слоты должны относиться к одному событию."
    override val errorSlotsMustSameOrganizer = "Все слоты должны принадлежать организатору события."
    override val errorSlotsUnavailable = "Один или несколько слотов недоступны."
    override val errorSlotsInPast = "Нельзя бронировать слоты в прошлом."
    override val errorSlotsMustBeConsecutive = "Слоты должны идти подряд."
    override val errorEventIdRequired = "Требуется идентификатор события."
    override val errorQuantityAtLeastOne = "Количество должно быть не меньше 1."
    override val errorPaidReservationRequired = "Для события нужна платная бронь."
    override val errorEventOrganizerInvalid = "Некорректный организатор события."
    override val errorEventOrganizerMissing = "У события не указан организатор."
    override val errorOrganizerCannotAccept = "Организатор не может принимать бронирования."
    override val errorOccurrenceRequired = "Нужно указать дату и время события."
    override val errorOccurrencePassed = "Выбранный сеанс уже прошёл."
    override val errorTicketsNotEnough = "Недостаточно доступных билетов."
    override val errorBookingOtherUser = "Бронь принадлежит другому пользователю."
    override val errorBookingNotAwaitingPayment = "Бронь не ожидает оплаты."
    override val errorBookingCancelled = "Бронь уже отменена."
    override val errorBookingNotActive = "Бронь больше не активна."
    override val errorBookingIssuedTickets = "По этой брони уже выданы билеты."
    override val errorEventRequiresPaymentFlow = "Это событие требует оплаты. Завершите покупку, чтобы продолжить."
    override val errorReservationQuantityExceeded = "Количество превышает зарезервированные места."
    override val errorTicketAlreadyValidated = "Билет уже проверен."
    override val errorTicketInactive = "Билет не активен."
    override val errorTicketAlreadyCancelled = "Билет уже отменён."
    override val errorTicketUsed = "Использованные билеты нельзя отменить."
    override val errorOccurrencesRequired = "Необходимо указать расписание."
    override val errorRequestRequired = "Тело запроса обязательно."
    override val errorBookingEventMismatch = "Бронь не относится к этому событию."
    override val errorBookingProcessed = "Бронь уже обработана."
    override val errorOverrideAmountAdminOnly = "Менять сумму могут только администраторы."
    override val errorOverrideAmountPositive = "Заданная сумма должна быть положительной."
    override val errorUnableDetermineTicketPrice = "Не удалось определить стоимость билета."
    override val errorEmailAlreadyRegistered = "Email уже зарегистрирован."
    override val errorInvalidCredentials = "Неверный email или пароль."
    override val errorAccountInactive = "Аккаунт не активирован."
    override val errorAccountDeleted = "Аккаунт удалён."
    override val errorAccountBalanceNotZero = "Перед удалением выведите доступный баланс."
    override val errorInvalidRefreshToken = "Неверный refresh token."
    override val errorAvatarDataUrlRequired = "Аватар нужно передавать как data URL."
    override val errorAvatarMustBeImage = "Аватар должен быть изображением."
    override val errorAvatarInvalidDataUrl = "Неверный формат data URL для аватара."
    override val errorStripeSignatureInvalid = "Неверная подпись Stripe."
    override val errorMediaUnsupportedFormat = "Неподдерживаемый формат изображения."
    override val errorReservationExpired = "Время ожидания платежа истекло. Начните бронирование заново."
    override val login = "Войти"
    override val register = "Регистрация"
    override val continueWithGoogle = "Продолжить с Google"
    override val continueWithApple = "Продолжить с Apple"
    override val logout = "Выйти"
    override val password = "Пароль"
    override val username = "Имя пользователя"
    override val firstName = "Имя"
    override val lastName = "Фамилия"
    override val confirmPassword = "Подтвердите пароль"
    override val alreadyHaveAccount = "Уже есть аккаунт?"
    override val dontHaveAccount = "Нет аккаунта?"
    override val loginHere = "Войдите здесь"
    override val registerHere = "Зарегистрируйтесь здесь"
    override val welcomeBack = "С возвращением!"
    override val createAccount = "Создать аккаунт"
    override val loginError = "Ошибка входа. Проверьте ваши данные."
    override val registerError = "Ошибка регистрации. Попробуйте ещё раз."
    override val passwordsDontMatch = "Пароли не совпадают"
    override val fillAllFields = "Пожалуйста, заполните все обязательные поля"
    override val invalidEmail = "Пожалуйста, введите корректный email"
    override val forgotPassword = "Забыли пароль?"
    override val passwordResetTitle = "Сброс пароля"
    override val passwordResetDescription = "Введите email, чтобы получить ссылку для сброса."
    override val passwordResetSetNewPassword = "Установите новый пароль"
    override val sendResetLink = "Отправить ссылку"
    override fun passwordResetEmailSent(email: String) =
        "Если для адреса $email есть аккаунт, мы отправили инструкцию."
    override val passwordResetTokenLabel = "Код сброса"
    override val passwordResetTokenDescription =
        "Вставьте код из письма или откройте ссылку с этого устройства."
    override val newPassword = "Новый пароль"
    override val resetPasswordAction = "Сохранить пароль"
    override val passwordResetSuccess = "Пароль обновлён! Теперь можно войти."
    override val backToLogin = "Вернуться ко входу"
    override val invalidPhone = "Неверный формат телефона"
    override val provideAnyContact = "Укажите телефон или email"
    override val checkContacts = "Проверьте корректность контактов"
    override val contactSubmitting = "Сохранение..."
    override val contactSubmitted = "Заявка отправлена"
    override val book = "Забронировать"
    override val bookFree = "Забронировать бесплатно"
    override val bookingSuccess = "Успешно забронировано!"
    override val bookingFailed = "Ошибка бронирования"
    override fun bookForPrice(price: String) = "Забронировать за $price"
    override val prev = "Назад"
    override val showAll = "Показать все"
    override val collapse = "Свернуть"
    override val missingTitle = "Укажите название мероприятия"
    override val missingDescription = "Укажите описание мероприятия"
    override val missingScheduleType = "Выберите тип расписания"
    override val missingDate = "Выберите дату мероприятия"
    override val missingTime = "Укажите время мероприятия"
    override val missingWeeklyDays = "Выберите дни недели"
    override val missingWeeklyTime = "Укажите время для еженедельного события"
    override val missingSlotDays = "Выберите дни для слотов"
    override val missingSlotStart = "Укажите время начала слотов"
    override val missingSlotEnd = "Укажите время окончания слотов"
    override val missingLocation = "Укажите место проведения мероприятия"
    override val optional = "Необязательно"

    // Organizer bookings section
    override val bookingsTitle = "Брони"
    override val unconfirmedRequestsTitle = "Заявки без подтверждения брони"
    override val detailsButton = "Подробнее"
    override val hideDetailsBooking = "Скрыть"
    override val noBookings = "Пока нет броней"
    override val noUnconfirmedRequests = "Нет заявок без подтверждения"
    override val ticketInfoLabel = "Билет"
    override val contactInfoLabel = "Контактная информация"
    override val paymentInfoLabel = "Оплата"
    override val loadingPayment = "Загрузка..."
    override val clientLabel = "Клиент"
    override val paymentAmount = "Сумма"
    override val paymentStatus = "Статус"
    override val paymentDate = "Дата"

    // App Store Banner
    override val appStoreBannerTitle = "Скачайте приложение"
    override val appStoreBannerMessage = "Установите наше приложение для лучшего опыта"
    override val downloadOnAppStore = "Загрузить в App Store"
    override val getItOnGooglePlay = "Доступно в Google Play"
    override val downloadAppLinks = "Скачать приложение"
    override val appStoreUnavailableMessage = "Извините, приложение проходит публикацию в сторе и вскоре будет доступно."

    // App Update
    override val updateAvailable = "Доступно обновление"
    override val updateRequired = "Требуется обновление"
    override val updateAvailableMessage = "Доступна новая версия iJoin. Обновитесь сейчас, чтобы получить последние функции и улучшения."
    override val updateRequiredMessage = "Пожалуйста, обновите iJoin для продолжения работы. Эта версия больше не поддерживается."
    override val updateNow = "Обновить"
    override val updateLater = "Позже"
    override val newVersion = "Новая версия"
    override val currentVersion = "Текущая версия"
    override val whatsNew = "Что нового"

    // AI Landing
    override val landingModeClassic = "Классический"
    override val landingModeAi = "AI продающая страница"
    override val landingModeTitle = "Тип страницы"
    override val landingDescriptionLabel = "Описание лендинга"
    override val landingDescriptionPlaceholder = "Опишите ваше мероприятие, и AI создаст красивую продающую страницу..."
    override val recordVoice = "Записать голос"
    override val stopRecording = "Остановить запись"
    override val transcribing = "Распознавание..."
    override val recordingTooShort = "Запись слишком короткая (минимум 3 секунды)"
    override val recordingTooLong = "Запись слишком длинная (максимум 5 минут)"
    override val microphoneAccessDenied = "Доступ к микрофону запрещён"
    override fun recordingDuration(seconds: Int) = "${seconds}с"
    override val enableLandingPageLabel = "Использовать лендинг"
    override val enableLandingPageDescription = " "//Скрыть описание, дресс-код, место и отзывы

    // Legal Documents
    override val termsOfService = "Условия использования"
    override val privacyPolicy = "Политика конфиденциальности"
    override val refundPolicy = "Политика возврата и отмены"
    override val organizerTerms = "Условия для организаторов"
    override val aiDataConsent = "Согласие на обработку данных ИИ"
    override val aiConsentTitle = "ИИ-функции используют сторонние сервисы"
    override val aiConsentDescription = "Некоторые функции приложения используют сервисы искусственного интеллекта от OpenAI и Google. При использовании этих функций определённый контент, который вы предоставляете, отправляется в эти сервисы для обработки."
    override val aiConsentDataSent = "Данные, которые могут быть отправлены:"
    override val aiConsentDataSentAudio = "Аудиозаписи (для транскрибации)"
    override val aiConsentDataSentDescription = "Описания мероприятий (для улучшения текста)"
    override val aiConsentDataSentLanding = "Данные лендинга (для генерации контента)"
    override val aiConsentProviders = "Данные обрабатываются OpenAI (OpenAI, L.L.C.) и Google (Google LLC). Ваши персональные данные аккаунта (имя, email) не отправляются, если они не являются частью контента, который вы отправляете. Полные условия доступны в документе «Согласие на обработку данных ИИ»."
    override val aiConsentOptional = "ИИ-функции опциональны. Вы можете пользоваться приложением без них."
    override val aiConsentAccept = "Принимаю"
    override val aiConsentDecline = "Не сейчас"
    override val iAgreeToThe = "Я принимаю следующие документы:"
    override val iAgreeToTerms = "Я принимаю Условия использования, Политику конфиденциальности и Политику возврата"
    override val iAgreeToOrganizerTerms = "Я принимаю Условия для организаторов"
    override val pleaseAcceptTerms = "Пожалуйста, примите условия для продолжения"
    override val pleaseAcceptOrganizerTerms = "Пожалуйста, примите Условия для организаторов для публикации мероприятий"
    override val viewDocument = "Просмотр"
    override val legalDocumentLoading = "Загрузка документа..."
    override val legalDocumentLoadError = "Не удалось загрузить документ"
    override val newUserGoogleNote = "Если вы новый пользователь, примите условия перед входом через Google:"
    override val legalDocumentsUpdated = "Условия обновлены"
    override val legalDocumentsUpdatedDescription = "Мы обновили наши условия. Пожалуйста, ознакомьтесь и примите обновленные документы для продолжения использования приложения."
    override val iAcceptUpdatedTerms = "Я принимаю обновленные условия"
    override val continueButton = "Продолжить"
}
